import angular from 'angular';

import * as Configuration from '../../app.constants.js';

export class ErrorService {
  constructor($uibModal, $window, $http, $state, $q, AlertingFactory, UserFactory) {
    this.$uibModal = $uibModal;
    this.$window = $window;
    this.$http = $http;
    this.$state = $state;
    this.$q = $q;
    this.AlertingFactory = AlertingFactory;
    this.UserFactory = UserFactory;

    this.redirectingToErrorPage = false;

    this.errorReasonsThatRedirectToLoginPage = {
      'auth-required-but-no-auth-present': 'error/login-page-message/please-connect',
      'client-session-does-not-match-server-session': 'error/login-page-message/session-expired-or-invalid',
      'no-session': 'error/login-page-message/session-expired-or-invalid',
      'session-is-closed': 'error/login-page-message/session-expired-or-invalid'
    };
    this.toState = null;
    this.toParams = null;
  }

  registerStartChange(toState, toParams) {
    this.toState = toState;
    this.toParams = toParams;
  }

  showErrorModal(title, message, useTranslator) {
    this.$uibModal.open({
      animation: true,
      template: require('./error.modal.html'),
      controller: 'ErrorController',
      resolve: {
        errorTitle: () => title,
        errorMessage: () => message,
        useTranslator: () => useTranslator,
        errorDetails: () => null,
      }
    });
  }

  showErrorModalWithDetails(title, message, details) {
    this.$uibModal.open({
      animation: true,
      template: require('./error.modal.html'),
      controller: 'ErrorController',
      resolve: {
        errorTitle: () => title,
        errorMessage: () => message,
        useTranslator: () => false,
        errorDetails: () => details,
      }
    });
  }

  redirectToPlatformUnavailableCb() {
    return response => {
      if (response && response.status === 500) {
        this.$state.go('platform-unavailable', {}, {
          location: false, // do not update URL, so that if users reload the page with F5 they are not "trapped" on the error page
        });
      }
      return this.$q.reject(response);
    }
  }

  _buildRedirectConfig(httpResponse) {
    const config = {
      redirectStateParams: {},
      redirectOptions: {}
    };
    switch (httpResponse.status) {
      case 401:
      case 403:
        let errorReason = null;
        if (httpResponse.data && httpResponse.data.error) {
          errorReason = httpResponse.data.error.reason;
        }
        if (errorReason in this.errorReasonsThatRedirectToLoginPage) {
          config.redirectStateName = 'no-auth.company.login';
          config.redirectStateParams.errorMessageKey = this.errorReasonsThatRedirectToLoginPage[errorReason];
        } else {
          config.redirectStateName = 'no-auth.company.error-403';
        }
        break;
      case 404:
        config.redirectStateName = 'no-auth.company.error-404';
        break;
      case 500:
        config.redirectStateName = 'no-auth.company.error-500';
        config.redirectOptions = {
          location: false, // do not update URL, so that if users reload the page with F5 they are not "trapped" on the error page
        };
        break;
      default:
        break;
    }
    return config;
  }

  /*
   * Redirects to an error page or the login page, depending on the given error.
   * If we go to the login page, the after-login state will be the last state we tried to transition to.
   */
  redirectToErrorPageFromToState(httpResponse) {
    this.redirectToErrorPage(httpResponse, this.toState, this.toParams);
  }

  /*
   * Redirects to an error page or the login page, depending on the given error.
   * If we go to the login page, the after-login state will be the given state and params.
   */
  redirectToErrorPage(httpResponse, afterLoginState, afterLoginParams) {
    if (!this.redirectingToErrorPage) {
      this.redirectingToErrorPage = true;
      const config = this._buildRedirectConfig(httpResponse);
      const companyName = this.UserFactory.getCompanyUrlNameFromStorage(afterLoginParams.companyId);
      config.redirectStateParams.companyName = companyName;
      config.redirectStateParams.destUrl = Configuration.constants.frontendBaseUrl + this.$state.href(afterLoginState, afterLoginParams);
      this.$state.go(config.redirectStateName, config.redirectStateParams, config.redirectOptions)
        .then(() => {
          // we will get here in case of success, but also if there was no companyId in the afterLoginParams 
          this.redirectingToErrorPage = false;
        });
    }
  }

  redirectToUnknownCompanyOrToBug(response, companyName) {
    if (response.status === 400) {
      // Redirects to `/unknown-company`.
      this.$state.go('no-auth.companyless.unknown-company', {
        companyName: companyName
      });
    } else {
      // Redirects to `/a/login`.
      this.$state.go('no-auth.companyless.login');
    }
  }

  static ErrorFactory($uibModal, $window, $http, $state, $q, AlertingFactory, UserFactory) {
    return new ErrorService($uibModal, $window, $http, $state, $q, AlertingFactory, UserFactory);
  }
}
ErrorService.ErrorFactory.$inject = ['$uibModal', '$window', '$http', '$state', '$q', 'AlertingFactory', 'UserFactory'];
